export default {
  loading: false,
  loadingAttachments: false,
  loadingBinnacle: false,
  error: '',
  showModal: false, // TODO: delete this.
  list: {}, // TODO: <-
  dashboard: {
    resume: {},
    approvals: [],
    approvalsList: [],
    indicators: [],
    flow: {},
    loading: false
  },
  pagination: {
    items: 0,
    pages: 0
  },
  trays: {},
  wizardData: {},
  selectedFile: {},
  binnacle: [],
  fileOnFlow: {
    detalle: {}
  },
  processType: 'tramitar',
  fileOnFlowAttachments: [],
  numerationFile: '',
  numerationFebosId: '',
  referenceApprovals: [],
  approvalsTemplates: [],
  purchaseTypes: [],
  templatePaginationData: null,
  categoryOptions: [],
  documentOptions: [],
  purchaseTypeOptions: [],
  reportTypeOptions: [],
  consequenceOptions: [],
  stepTypes: [],
  stepRoles: [],
  aprovalTemplate: {},
  infoCU: {},
  documentTypeReferences: []
};
